import React from "react";
const LoadingPage = () => (
  <div className="loader">
    <img className="loader__img" src="/img/loader.gif" />
  </div>
);

export default LoadingPage;
